import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatGPT3.css';

const WhatGPT3 = (props) => (
  <div className='gpt3__whatgpt3 '>
    <div className="gpt3__whatgpt3-card gradient__card section__margin" id="wgpt3">
          <div className="gpt3__whatgpt3-feature">
            <Feature title="What is AdaLink" text="AdaLink is a platform designed to facilitate meaningful connections and partnerships within the Cardano ecosystem. It will serve as a bridge between Stake Pool Operators (SPOs), influencers, NFT project leaders, marketers, and large capital delegators (whales)." />
          </div>
          <div className='iframe-container-limiter'>
            <div className='iframe-container'>
              <iframe src="https://player.vimeo.com/video/851964618?h=4d240c4840" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
<p><a href="https://vimeo.com/851964618">AdaLink: Connect, Collaborate &amp; Grow</a> from <a href="https://vimeo.com/adalink">AdaLink</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
            </div>
          </div>

          
          
          <div className="gpt3__whatgpt3-heading">
            <h1 className="gradient__text">The possibilities are endless</h1>
            <p onClick={() => props.setMiddleWindowTrigger(true)}>Explore Registered SPO's</p>
          </div>
          <div className="gpt3__whatgpt3-container">
            <Feature title="Discoverability" text="Any SPO can register on the platform and will automatically be visible to users." />
            <Feature title="Reachability" text="Content creators, influencers, NFT project leaders, marketers, and large capital delegators (whales) are referred to as 'affiliates'. Affiliates can register on the platform and will be able to send offers to available SPOs." />
            <Feature title="Profit Sharing" text="Rewards coming from pools margin get distributed among SPOs and their affiliates." />
          </div>
    </div>
  </div>
);

export default WhatGPT3;